class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
    this.startAutoClose();
    this.notification.addEventListener('mouseenter', this.pauseAutoClose);
    this.notification.addEventListener('mouseleave', this.startAutoClose);
    // Ignoramos el foco que cae sobre el panel mismo (el .focus() de
    // accesibilidad de arriba lo dispara al abrir) — solo pausamos cuando
    // el foco entra a un elemento interactivo real dentro del panel
    // (tab, click en un botón/link), que sí es interacción del usuario.
    this.notification.addEventListener('focusin', (evt) => {
      if (evt.target !== this.notification) this.pauseAutoClose();
    });
    this.notification.addEventListener('focusout', this.startAutoClose);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    this.pauseAutoClose();

    removeTrapFocus(this.activeElement);
  }

  startAutoClose = () => {
    this.pauseAutoClose();
    this.autoCloseTimer = setTimeout(() => this.close(), 5000);
  };

  pauseAutoClose = () => {
    if (this.autoCloseTimer) clearTimeout(this.autoCloseTimer);
  };

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    if (parsedState.sections) {
      this.getSectionsToRender().forEach((section) => {
        const el = document.getElementById(section.id);
        if (!el) return;
        const html = parsedState.sections[section.id];
        if (!html) return;
        const content = this.getSectionInnerHTML(html, section.selector);
        if (content !== null) el.innerHTML = content;
      });
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
